import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChildOnboardingStore } from '@zero/onboarding/domain';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'child-onboarding-container',
  imports: [IconComponent, ButtonComponent, TranslocoPipe, AsyncPipe, LoadingIndicatorDirective],
  templateUrl: './onboarding-container.component.html',
  styleUrl: './onboarding-container.component.scss',
})
export class OnboardingContainerComponent {
  public hideForward = input<boolean>(false);
  public hideBack = input<boolean>(false);
  public formValid = input<boolean>(false);
  public buttonLabel = input<string>();
  public loading = input<boolean>(false);

  public forward = output<void>();
  public back = output<void>();

  public readonly store = inject(ChildOnboardingStore);
}
